module.exports = function validate(code) {
	var originalControllDigit = code.slice(-1);
	var isEvenCode = code.length % 2 == 0;
	var evenSum = 0;
	var oddSum = 0;
	for(var i = 0; i < code.length - 1; i++) {
		if(i%2) {
			evenSum += Number(code.charAt(i));
		} else {
			oddSum += Number(code.charAt(i));
		}
	}
	var sum = 0;
	if(isEvenCode) {
		sum = evenSum + (oddSum*3);
	} else {
		sum = (evenSum*3) + oddSum;
	}

	var nearestMultipleOfTen = getNearestMultipleOfTen(sum);
	var calculatedControlDigit = nearestMultipleOfTen - sum;
	return calculatedControlDigit == originalControllDigit;
}

function getNearestMultipleOfTen(n){
	if(n%10 == 0) return n;
	return Math.floor(n/10)*10+10;
}